<template>
	<v-dialog v-model="isDialogShow" persistent max-width="460" content-class="rounded-xl">
		<v-card>
			<v-card-text class="text-center">
				<div class="pt-3 d-flex justify-center">
					<v-col cols="6">
						<v-img src="/assets/ilustration/confirm-vo.svg"></v-img>
					</v-col>
				</div>
				<template v-if="Object.keys(successResponse).length > 0">
					<div class="font-size-11 mb-4">Anda berhasil melakukan pengiriman <b>{{ serialqty }} Serial {{ serialtype }}</b> kepada :</div>
					<div class="d-block text-left mb-2" v-if="successResponse.receiver.member_ref_network_code">
						<div class="d-flex justify-center align-center text-center">
							<div class="px-0 col-sm-5 py-0 text-right">
								<span>Kode Mitra</span>
							</div>
							<span class="col-sm-2 text-center py-0 ">:</span>
							<div class="px-0 col-sm-5 font-weight-bold py-0 text-left">{{ successResponse.receiver.member_ref_network_code | emptyData }}</div>
						</div>
					</div>
					<div class="d-block text-left mb-2" v-if="successResponse.receiver.member_name">
						<div class="d-flex justify-center align-center text-center">
							<div class="px-0 col-sm-5 text-right py-0 ">
								<span>Nama Mitra</span>
							</div>
							<span class="col-sm-2 text-center py-0 ">:</span>
							<div class="px-0 col-sm-5 font-weight-bold py-0 text-left">{{ successResponse.receiver.member_name | emptyData }}</div>
						</div>
					</div>
					<div class="pt-1 d-flex justify-center" v-if="false">
						<div class="font-size-11 font-weight-bold primary--text">{{ successResponse.receiver.serial_buyed_mobilephone }}</div>
					</div>
					<!-- <div class="pt-3 font-size-11">List Serial Dikirim</div>
					<div class="pt-1 font-size-11 grey--text text--darken-1 font-weight-bold">
						<span v-for="(serial, i) in successResponse.serial" :key="i">
							{{ serial.serial_id + (i != successResponse.serial.length - 1 ? ',' : '') }}
						</span>
					</div> -->
				</template>
			</v-card-text>
			<v-card-actions>
				<v-spacer></v-spacer>
				<v-btn color="grey darken-1" outlined class="text-capitalize rounded-xl" @click.stop="modalHide">{{ closeText }}</v-btn>
				<v-spacer></v-spacer>
			</v-card-actions>
		</v-card>
	</v-dialog>
</template>

<script>
export default {
	data () {
		return {
			isDialogShow: false,
			closeText: 'Tutup',
		}
	},
	props: {
		successResponse: Object,
		serialqty: Number,
		serialtype: String,
		// network_code: String,
		// nama_mitra: String,
	},
	computed: {
	},
	methods: {
		modalHide() {
			this.isDialogShow = false
			this.$emit('action')
		},
		modalShow() {
			this.isDialogShow = true
		},
	}
};
</script>